// 1. 导入 Vue Router 4 核心方法
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

// 布局组件
import FrontLayout from '../layouts/FrontLayout.vue'
import AdminLayout from '../layouts/admin/admin.vue'

// 前台页面
import About from '@/views/front/About.vue'
import Home from '../views/front/Home.vue'
import My from '../views/front/My.vue'
import Usermanage from '@/views/front/Usermanage.vue'
import product from '../views/front/product/Product.vue'
import indexinfo from '../views/front/index-info/index-info.vue'
import PublishClothes from '../layouts/PublishClothes.vue' // 确保无空格
import ProductManage from '../views/front/productManage/productManage.vue'
import colorcard from '../views/front/colorcard/colorcard.vue'
import ColorList from '../views/front/colorcards/colorcard.vue' //色卡管理模块
import dataAnalysis from '../views/front/dataAnalysis/dataAnalysis.vue'
import promotion from '../views/front/promotion/promotion.vue'
import storeSet from '../views/front/storeSet/storeSet.vue'
import colorcardAdd from '../views/front/colorcardAdd/colorcardAdd.vue'
import colorcardStockRectify from '../views/front/colorcardStockRectify/colorcardStockRectify..vue'
import colorcardQrcodeList from '../views/front/colorcardQrcodeList/colorcardQrcodeList.vue'
import colorcardDaily from '../views/front/colorcardDaily/colorcardDaily.vue'
import colorcardStock from '../views/front/colorcardStock/colorcardStock.vue'
import colorcardDistribute from '../views/front/colorcardDistribute/colorcardDistribute.vue'
import colorcardAddList from '../views/front/colorcardAddList/colorcardAddList.vue'
import basicData from '../views/front/basicData/basicData.vue'
import basicDatas from '../views/front/basicDatas/basicDatas.vue'
import baseProduct from '../views/front/baseProduct/baseProduct.vue'
import productFabricCategory from '../views/front/productFabricCategory/productFabricCategory.vue'
import subAccount from '../views/front/subAccount/subAccount.vue'
import colorcardReceiver from '../views/front/colorcardReceiver/colorcardReceiver.vue'
import colorcardDailyList from '../views/front/colorcardDailyList/colorcardDailyList.vue'
import salesPerson from '../views/front/salesPerson/salesPerson.vue'
import colorcardDistributeAnalysis from '../views/front/colorcardDistributeAnalysis/colorcardDistributeAnalysis.vue'
import profile from '../views/front/profile.vue'

// 后台页面
import AdminLogin from '@/views/admins/Login'

// 前台路由（无/yy2126前缀）
const frontRoutes = [
    {
        path: '/',
        component: FrontLayout, // 一级布局
        children: [
            { path: "", redirect: '/about' },
            { path: 'about', name: 'About', component: About },
            { path: 'home', name: 'Home', component: Home },
            { path: 'my', name: 'My', component: My },
            { path: 'usermanage', name: 'Usermanage', component: Usermanage },

        ]
    },
    {
        path: '/profile',
        name: 'profile',
        component: profile,
    },
    {
        path: '/publish-clothes', // 一级子路由
        name: 'publish-clothes',
        component: PublishClothes,
        children: [
            { path: "", redirect: 'indexinfo' }, // 默认跳product子路由 店铺首页
            { path: 'indexinfo', name: 'indexinfo', component: indexinfo }, // 二级子路由 店铺首页
            { path: 'product', name: 'PublishProduct', component: product }, // 二级子路由 样衣发布
            { path: 'productManage', name: 'ProductManage', component: ProductManage }, // 二级子路由 样衣管理
            {
                path: 'basicData', // basicData 作为父路由
                name: 'basicData',
                component: basicData,
                children: [
                    { path: "", redirect: 'basicDatas' }, // basicDatas 默认子路由 产品资料
                    { path: 'basicDatas', name: 'basicDatas', component: basicDatas },//基本资料模块
                    { path: 'baseProduct', name: 'baseProduct', component: baseProduct }, //产品资料
                    { path: 'productFabricCategory', name: 'productFabricCategory', component: productFabricCategory }, //面料类别
                    { path: 'subAccount', name: 'subAccount', component: subAccount }, //总子账号
                    { path: 'salesPerson', name: 'salesPerson', component: salesPerson },//销售人员二维码
                ]
            },
            {
                path: 'colorcard', // colorcard 作为父路由
                name: 'colorcard',
                component: colorcard,
                children: [
                    { path: "", redirect: 'list' }, // colorcard 默认子路由 色卡管理
                    { path: 'list', name: 'list', component: ColorList },//色卡管理
                    { path: 'storeSet', name: 'storeSet', component: storeSet }, //门店设置
                    { path: 'colorcardAdd', name: 'colorcardAdd', component: colorcardAdd }, //色卡新增
                    { path: 'colorcardStockRectify', name: 'colorcardStockRectify', component: colorcardStockRectify }, //库存清点
                    { path: 'colorcardQrcodeList', name: 'colorcardQrcodeList', component: colorcardQrcodeList },//色卡码列表与打印
                    { path: 'colorcardDaily', name: 'colorcardDaily', component: colorcardDaily },//每天色卡清单
                    { path: 'colorcardDailyList', name: 'colorcardDailyList', component: colorcardDailyList },//每天色卡清单列表
                    { path: 'colorcardStock', name: 'colorcardStock', component: colorcardStock },//色卡库存结存表
                    { path: 'colorcardDistribute', name: 'colorcardDistribute', component: colorcardDistribute },//色卡-客户派发表
                    { path: 'colorcardAddList', name: 'colorcardAddList', component: colorcardAddList },//色卡新增列表
                    { path: 'colorcardReceiver', name: 'colorcardReceiver', component: colorcardReceiver },//色卡色卡领取名单
                    { path: 'colorcardDistributeAnalysis', name: 'colorcardDistributeAnalysis', component: colorcardDistributeAnalysis },//销售派发色卡分析表

                ]
            },
            { path: 'dataAnalysis', name: 'dataAnalysis', component: dataAnalysis }, // 二级子路由 数据看板
            { path: 'promotion', name: 'promotion', component: promotion }, // 二级子路由 关联推广
        ]
    },
]

// 后台路由（带/yy2126前缀）
const adminRoutes = [
    {
        path: "/yy2126",
        component: AdminLayout,
        meta: { requiresAuth: true },
    },
    {
        path: '/yy2126/login',
        name: 'AdminLogin',
        component: AdminLogin
    }
]

// 合并路由
const routes = [...frontRoutes, ...adminRoutes]

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes
})

// 全局路由守卫：仅前台路由校验token，后台/yy2126全部放行
router.beforeEach((to, from, next) => {
    const isAdminRoute = to.path.startsWith('/yy2126')
    const frontToken = store.state.frontToken

    // 后台路由直接放行
    if (isAdminRoute) {
        return next()
    }

    // 如果当前就是about页面，直接放行，不再校验
    if (to.path === '/about' || to.path === '/profile') {
        return next()
    }

    // 其他前台页面，无token去about，有token正常走
    if (!frontToken) {
        next('/about')
    } else {
        next()
    }
})


// 导出路由实例
export default router